import { render, staticRenderFns } from "./BannedIndustries.vue?vue&type=template&id=1776ffe3&"
import script from "./BannedIndustries.vue?vue&type=script&lang=ts&"
export * from "./BannedIndustries.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports